import { Route, Routes } from 'react-router-dom';
import {SURVEY_PAGES} from '../utils/Constants';
import SurveyPage from '../survey';
import WLSurveyPage from '../wlsurvey'
import EngagementSurveyPage from 'engagementsurvey';

const AppRoutes = () =>{
    return(
        <Routes>
            <Route path={SURVEY_PAGES.SurveyPage}
                element={
                    <SurveyPage></SurveyPage>
                }
            />   
            <Route path={SURVEY_PAGES.EngagementSurvey}
                element={
                    <EngagementSurveyPage></EngagementSurveyPage>
                }
            />   
            <Route path={SURVEY_PAGES.WLSurveyPage}
                element={
                    <WLSurveyPage></WLSurveyPage>
                }
            />              
        </Routes>
    );
};

export default AppRoutes;